import React, { Component } from 'react';
import {  observer } from 'mobx-react'
import { Tooltip } from '@mui/material';
import { Apartment } from '@mui/icons-material';
import { ViewTableRepresentante } from './ViewTableRepresentante';
import { IParteBasica } from '../../modelo/Partes';

interface IPropsViewListParte {
    parte: IParteBasica;
}

class ViewListParte extends React.Component<IPropsViewListParte> {

    render() {
        return (
            <li className="lista">
                <div className="titulo">
                    {this.props.parte.tipo}
                </div>
                <Tooltip title={
                    this.props.parte.nomeSocial
                        ? `${this.props.parte.nomeSocial} (registrado(a) civilmente como ${this.props.parte.nome})`
                        : ''
                } placement='bottom-start'>
                    <div className="lista-align-left center">
                        {(this.props.parte.nomeSocial ? this.props.parte.nomeSocial : this.props.parte.nome) + (this.props.parte.registroComplementar ? ' (' + this.props.parte.registroComplementar + ')' : '')}
                        {this.props.parte.procuradoria?.nome &&
                            <Tooltip title={this.props.parte.procuradoria?.nome}>
                                <Apartment />
                            </Tooltip>
                        }
                    </div>
                </Tooltip>
                <div className="lista-align-left">
                    <ViewTableRepresentante representantes={this.props.parte.representantes} />
                </div>
            </li>
        );
    }
}

export default observer(ViewListParte);
